module.exports = __webpack_public_path__ + "static/media/vat-address.ac4035c3.svg";